import { TranslationsContext } from "@teliaee/telia-translate";
import React from "react";
import { AnalyticsProvider } from "telia-front-react";
import MissingInformationModal from "./content/MissingInformationModal.mjs";
import ValidateInformationModal from "./content/ValidateInformationModal.mjs";
import MainProvider from "./providers/MainProvider.mjs";
import { useContactInfo } from "./providers/ContactInfoProvider.mjs";
import { ContactInfoStatusValue } from "./interfaces/ContactInfoInterfaces.mjs";
import { canConfirmInformation, getAllContactInfoStatuses } from "./util/ContactInfoUtil.mjs";
import { FetchStatus } from "./util/FetchStatus.mjs";
const ContactsUpdatePrompt = (props) => {
  return /* @__PURE__ */ React.createElement(MainProvider, { ...props }, /* @__PURE__ */ React.createElement(ContactsUpdatePromptInner, { ...props }));
};
const ContactsUpdatePromptInner = (props) => {
  const { translations } = React.useContext(TranslationsContext);
  const { fetchCheckContactInfosFlag, contactInfoStatusesState, isLoading } = useContactInfo();
  const hasTranslations = Object.keys(translations || {}).length;
  React.useEffect(() => {
    fetchCheckContactInfosFlag();
  }, []);
  React.useEffect(() => {
    var _a;
    if (contactInfoStatusesState.status === FetchStatus.FETCHED) {
      (_a = window.dataLayer) == null ? void 0 : _a.push({
        event: "AutoEvent",
        eventCategory: document.title,
        eventLabel: "Show contacts info update modal",
        eventAction: getEventActionForModalType()
      });
    }
  }, [contactInfoStatusesState.status]);
  const isMissingInformation = () => {
    return getAllContactInfoStatuses(contactInfoStatusesState.contactInfoStatuses).some((status) => status === ContactInfoStatusValue.MISSING);
  };
  const mustValidateInformation = () => {
    const { email, phone, general } = contactInfoStatusesState.contactInfoStatuses;
    const infoStatuses = [email, phone].flat();
    return infoStatuses.some((status) => status === ContactInfoStatusValue.UNVALIDATED) || general !== ContactInfoStatusValue.OK;
  };
  const getEventActionForModalType = () => {
    if (isMissingInformation()) {
      return "Missing data";
    }
    if (mustValidateInformation()) {
      return canConfirmInformation(contactInfoStatusesState.contactInfoStatuses) ? "Confirm data" : "Contact details unconfirmed";
    }
    return null;
  };
  if (!hasTranslations && ["et", "ru", "en"].includes(props.lang) || isLoading() || !(isMissingInformation() || mustValidateInformation())) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    AnalyticsProvider,
    {
      event: "AutoEvent",
      page: document.title,
      group: "Updating of data",
      onPush: async (data) => {
        var _a;
        return (_a = window.dataLayer) == null ? void 0 : _a.push({
          event: data.event,
          eventCategory: data.page,
          eventLabel: data.id,
          eventAction: getEventActionForModalType()
        });
      }
    },
    isMissingInformation() ? /* @__PURE__ */ React.createElement(MissingInformationModal, null) : mustValidateInformation() ? /* @__PURE__ */ React.createElement(ValidateInformationModal, null) : null
  );
};
export {
  ContactsUpdatePrompt,
  ContactsUpdatePromptInner
};
